/* eslint-disable react/prop-types */
/* @flow */
import React from 'react';
import withBoundary from 'component/ErrorBoundary/withBoundary';
import { isAlwaysOnTitleBarEmpty } from 'store/modules/conference/functions';

const ConferenceInfoContainer = ({ visible, children, id }) => (
  <div
    className={`subject${isAlwaysOnTitleBarEmpty() ? '' : ' with-always-on'}${
      visible ? ' visible' : ''
    }`}
    id={id}>
    <div className={'subject-info-container'}>{children}</div>
  </div>
);
export default React.memo(withBoundary(ConferenceInfoContainer));
